import ReactLoader from 'OK/react-loader';
import { VISIBILITY_TOOLBAR_NAV, INDICATE_LOADING_REACT_TOOLBAR_SEARCH } from 'OK/ToolbarSearchEventBuses';

var activated = false;
var lazyLoading = false;

var TOOLBAR_SEARCH_BTN_CLASS = 'js-toolbar-search-btn';


var events = [
    'focus',
    'mousedown',
    'keydown',
    'click'
];

var reactLoader = new ReactLoader();

var searchBtn;

function activate(el) {
    function load(e) {
        if (activated) {
            return;
        }

        activated = true;
        reactLoader.activate(el);

        events.forEach(function (name) {
            el.removeEventListener(name, load);
        });
        if (lazyLoading) {
            var target = e && e.target ? e.target : undefined;
            // если попали на кнопку поиска, не нужно ничего делать
            if (searchBtn && !searchBtn.contains(target)) {
                VISIBILITY_TOOLBAR_NAV.emit({hide: true}, null);
                INDICATE_LOADING_REACT_TOOLBAR_SEARCH.emit({loading: true}, null);
            }
        }
    }

    if (el.getAttribute('data-lazy-loading') === 'true') {
        lazyLoading = true;
        events.forEach(function (name) {
            el.addEventListener(name, load);
        });

        var classNameActiveEl = document.activeElement.getAttribute('class');

        searchBtn = el.querySelector("."+TOOLBAR_SEARCH_BTN_CLASS);

        if (el.getElementsByClassName(classNameActiveEl).length) {
            load();
        }

    } else {
        load();
    }
}

function deactivate() {
    if (activated) {
        reactLoader.deactivate();
    }
    activated = false;
    lazyLoading = false;
}

export default { activate, deactivate };

export { activate, deactivate };
